﻿<template>
    <div >
        <button v-if="isSmallScreen() && isMobile()" @click="goTo('calendar_div')" type="button" class="hover:no-underline rounded-full my-2 my-2 mx-0 md:mx-2 px-3 py-1 text-sm button button-bluelight ">
            <svg class="h-5 w-5 mr-1 inline" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 512 512" stroke="currentColor">
                <path fill="currentColor" d="M64 191L98 157 262 320 426 157 460 191 262 387 64 191Z" class=""></path>
            </svg>
            Jump to Dates
        </button>
        <tour_heading  :product=product></tour_heading>

        <div class="lg:flex mt-2">
            <div class="left-col w-full lg:w-6/12 pb-4">
                <div class="flex flex-col lg:flex-row lg:items-center lg:justify-between rounded p-3 bg-blue-50 shadow text-blue-700 text-base gap-2">
                    <div class="flex items-center">
                        <svg class="h-5 w-5 mr-2 text-blue-400 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/>
                        </svg>
                        <span class="font-medium">Selected date:</span>
                        <span class="ml-2">
                            <template v-if="get_Selected_Date()">
                                <b>{{ get_Selected_Date() }}</b>
                            </template>
                            <template v-else>
                                <span class="italic text-gray-500">No date selected</span>
                            </template>
                        </span>
                    </div>
                    <span v-if="isCalendarAddonTour()" class="flex items-center gap-1 text-sm shrink-0 font-bold" style="color: #CF3B71">
                        <span class="text-base">*</span>
                        {{add_on_name}} Add-On Available
                    </span>
                </div>
                
                <calendar class="border-t-2 border-grey-lightest" id="calendar_div" :trip_index="trip_index" :product="product" :tour_ids="tour_ids" :selected_tour_id="selected_tour_id" @monthChange="onMonthChange" @dateChange="onDateChange" ref="calendar"></calendar>
                <div
                    v-if="!isAgent_Login() && tempBookingNotes(product?.tour_id)"
                    class="flex items-center gap-2 mt-3 px-4 py-2.5 rounded text-sm "
                >
                    <svg xmlns="http://www.w3.org/2000/svg" class="shrink-0 h-4 w-4 text-blue-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M13 16h-1v-4h-1m1-4h.01M12 2a10 10 0 100 20A10 10 0 0012 2z" />
                    </svg>
                    <span v-html="getTempBookingNotes()"></span>
                </div>
            </div>

            <div class="right-col w-full lg:w-6/12 lg:ml-4 mt-4 lg:mt-0">
                <passenger_details :hidden_initially=false @calendar_update="onCalendarUpdate" ref="passenger_details" :tour_id=tour_id></passenger_details>
                <pickup_point :trip_index=trip_index ref="pickup_points"></pickup_point>
                <sales_group :trip_index=trip_index :tour_id=tour_id  :year="year" :month="month" @selectedTour="onSelectedTour" ref="sales_group"></sales_group>
                <basket :trip_index=trip_index :tour_id="tour_id" @Add_To_Cart="Add_To_Cart"></basket>
            </div>
        </div>
    </div>
</template>

<script lang="ts" src="./tour_details.ts"></script>